import styled from 'styled-components'
import { TableHead } from '@mui/material'
import { device } from 'constants/media-query'
import Table from '@mui/material/Table'
import TableRow from '@mui/material/TableRow'

export const StyledPurchaseHistoryContainer = styled.div``
export const StyledTabContentTitle = styled.h1`
  font-size: 20px;
  font-weight: 500;
  margin-top: 0px;
  margin-bottom: 25px;
  margin-right: 8px;
  margin-left: 8px;
  @media ${device.desktop} {
    margin-bottom: 32px;
  }
`
export const StyledTableContainer = styled.div`
  background: #fff;
  box-shadow: none;
  border-radius: 4px;
  max-width: 100%;
  width: max-content;
  position: relative;
  overflow: hidden;
  @media ${device.desktop} {
    box-shadow: rgba(39, 39, 39, 0.1) 0 4px 16px 0;
  }
`

export const StyledTable = styled(Table)`
  table-layout: fixed;
  min-width: 650px;
  box-shadow: none;
  border-radius: 4px;

  @media ${device.desktop} {
    min-width: unset;
    width: 100px;
  }
`
export const StyledTableHead = styled(TableHead)`
  background-color: rgba(243, 243, 243, 1);
  padding: 0px;
  height: 47px;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
`

export const StyledTableRow = styled(TableRow)`
  height: 49px;
  border-bottom: 1px solid #d7d7d7;
  font-family: ${({ theme }) => theme.fonts.inter}, sans-serif;
`
export const StyledTableCellHead = styled.th`
  font-size: 12px;
  font-weight: 600;
  padding: 20px 20px 12px 20px;
  text-align: center;
`

export const StyledTableCell = styled.th`
  height: 49px;
  padding: 20px 20px 12px 20px;
  color: #2e2e2e;
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`
